var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"blocker"},[_c('div',{staticClass:"blocker-inner"},[_c('div',{staticClass:"blocker-spinner"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }